import { type FC } from "react";

import { cn } from "@/shared/lib/utils";
import { FieldError } from "@/shared/components/ui/FieldError";
import type { FlowQuestion } from "@/shared/constants/flowTypes";

interface TextFieldProps {
  question: FlowQuestion;
  value: string;
  onChange: (value: string) => void;
  errorMessage?: string;
}

export const TextField: FC<TextFieldProps> = ({ question, value, onChange, errorMessage }) => {
  const maxLength = question.validation?.maxLength;
  const showCharCount = maxLength !== undefined;

  return (
    <div className="flex flex-col gap-2">
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={question.placeholder}
        maxLength={maxLength}
        rows={4}
        className={cn(
          "w-full resize-none rounded-lg border border-primary bg-white px-4 py-3",
          "text-sm placeholder:text-placeholder",
          "focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand",
          errorMessage && "border-destructive",
        )}
      />
      {showCharCount && (
        <p className="text-right text-2xs text-secondary">
          {value.length}/{maxLength}
        </p>
      )}
      <FieldError message={errorMessage} />
    </div>
  );
};
